<app-page-meta pageTitle="finzy - Investments"></app-page-meta>
<app-header></app-header>
<div class="container-fluid">
    <div class="row">
        <app-investormenu></app-investormenu>
        <div class="col-xs-12 col-md-10 col-lg-11 main-content">
            <div class="row finzy-row7">
                <div class="finzy-p-txt4 finzy-blue">
                    Here are your investment details
                </div>
                <div>
                    <p class="finzy-p-txt4 finzy-margin-10">
                        Loans are getting filled fast on finzy! See the loans funded by other investors 
                        <a
                            [class.link_disabled]="isFINXLender"
                            [attr.disabled]="isFINXLender"
                            [routerLink]="isFINXLender ? [] : ['/recently-filled-loans']">here.
                        </a>
                    </p>
                </div>
                <div class="col-md-12 metrics-table pt-4 pb-4">
                    <p>
                        <mat-toolbar class="finzy-blue">
                            <span>Portfolios</span>
                        </mat-toolbar>
                    </p>
                    <div class="row finzy-portfolio-row">
                        <div *ngIf="loader.spin === true || preferences === undefined || metrics === undefined"
                            class="spinner-section">
                            <mat-spinner [diameter]="35" class="col-xs-offset-6"></mat-spinner>
                        </div>
                        <div 
                            class="col-sm-3 finzy-portfolio"
                            [ngClass]="{disable_background_cursor: isFINXLender}"
                            *ngIf="loader.spin === false && preferences && isPortfolioCreationEnabled() && createPortfolioAllowed">
                            <div class="new-portfolio" (click)="openDialog()">
                                <p class="create">CREATE NEW PORTFOLIO</p>
                                <p class="add"><img src="../../assets/images/create-new-portfolio.svg"></p>
                            </div>
                            <p class="finzy-p-txt3">AMOUNT IN WALLET</p>
                            <p class="finzy-p-txt4 finzy-blue">
                                <span class="rupees finzy-blue">
                                    <app-indian-currency-formatter [amount]="walletAmount">
                                    </app-indian-currency-formatter>
                                </span>
                            </p>
                        </div>

                        <div class="col-sm-8 col-sm-offset-2 limit-reached-note"
                            *ngIf="metrics && !isPortfolioCreationEnabled()">
                            <p><i class="fa fa-info-circle text-color-finzy-blue"></i>
                                <span
                                    *ngIf="areAutomaticInvestmentsFromWalletEnabled(); else principalOutstandingBreachingSection">
                                    At this moment you won’t be able to create a new portfolio as you’ve opted for
                                    finzyBolt. You can change your
                                    preference <a [routerLink]="['/preferences']">here</a>.</span>
                                <ng-template #principalOutstandingBreachingSection>
                                    At this moment you won’t be able to create a new portfolio as you’ve already
                                    reached or are about to reach the
                                    &#8377; 50 lakhs principal outstanding limit on finzy.
                                </ng-template>
                            </p>
                        </div>
                        <div *ngIf="lenderPortfolios?.length > 0">

                            <div *ngFor="let portfolio_info of lenderPortfolios">
                                <div class="col-sm-3 finzy-portfolio"
                                    [ngClass]="{'pending-border' : portfolio_info.remaining_amt != 0}"
                                    *ngIf="portfolio_info.portfolio_type === 'reinvest' || portfolio_info.portfolio_type === 'finzy_bolt'"
                                    (click)="goToPortfolio(portfolio_info._id)">
                                    <div class="ribbon"
                                        *ngIf="portfolio_info.remaining_amt != 0 &&
                       ['auto_invest', 'hybrid_invest', 'reinvest', 'finzy_bolt'].includes(portfolio_info.portfolio_type)">
                                        <span>IN PROGRESS</span>
                                    </div>
                                    <p class="finzy-p-txt1">{{portfolio_info.portfolio_name}}
                                        <app-tooltip placement="bottom"
                                            *ngIf="portfolio_info.portfolio_type === 'finzy_bolt'">
                                            <i class="info-icon material-icons" trigger>info_outline</i>
                                            <div content style="max-width: 300px;">For your convenience, all the loans
                                                invested through
                                                finzyBolt portfolios will now be displayed under this consolidated
                                                portfolio section.
                                                Detailed information regarding all loans invested through finzyBolt
                                                portfolios will be
                                                available in this section.
                                            </div>
                                        </app-tooltip>
                                    </p>

                                    <p class="finzy-p-txt2">
                                        <!-- {{portfolio_info.risk}} -->
                                        ({{portfolio_info.portfolio_type}})
                                    </p>

                                    <div *ngIf="portfolio_info.investment_amt != 0">


                                        <div class="row finzy-rowtop"
                                            *ngIf="portfolio_info.portfolio_type == 'manual_invest' || portfolio_info.remaining_amt == 0">
                                            <div class="donutportfolio">

                                                <div style="text-align: center;">
                                                    <app-doughnut
                                                        [dataSet]="findChartDataForPortfolio(portfolio_info._id)"
                                                        [centerText]="(portfolio_info.roi ? portfolio_info.roi : '--') + '%'">
                                                    </app-doughnut>
                                                </div>

                                            </div>
                                        </div>


                                    </div>

                                    <div class="auto-invest-portfolio-remaining"
                                        *ngIf="portfolio_info.remaining_amt != 0">
                                        <div class="remaining-amount">
                                            <p class="finzy-p-txt4"><span class="rupees">
                                                    <app-indian-currency-formatter
                                                        [amount]="portfolio_info.remaining_amt">
                                                    </app-indian-currency-formatter>
                                                </span>
                                            </p>
                                            <p class="finzy-p-txt3">REMAINING AMOUNT YET TO BE INVESTED</p>
                                        </div>
                                        <div class="investment-amount">
                                            <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                            <p class="finzy-p-txt4"><span class="rupees">
                                                    <app-indian-currency-formatter
                                                        [amount]="portfolio_info.investment_amt">
                                                    </app-indian-currency-formatter>
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    <div *ngIf="portfolio_info.remaining_amt == 0">
                                        <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                        <p class="finzy-p-txt4 finzy-blue"><span class="rupees finzy-blue">
                                                <app-indian-currency-formatter [amount]="portfolio_info.investment_amt">
                                                </app-indian-currency-formatter>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="isShowMoreRequired && preferences">
                                <div *ngFor="let portfolio_info of fewLenderPortfolios">
                                    <div class="col-sm-3 finzy-portfolio"
                                        [ngClass]="{'pending-border' : portfolio_info.remaining_amt != 0}"
                                        *ngIf="portfolio_info.portfolio_type != 'reinvest' && portfolio_info.portfolio_type !== 'finzy_bolt'"
                                        (click)="goToPortfolio(portfolio_info._id)">
                                        <div class="ribbon"
                                            *ngIf="portfolio_info.remaining_amt != 0 &&
                       ['auto_invest', 'hybrid_invest', 'reinvest', 'finzy_bolt'].includes(portfolio_info.portfolio_type) ">
                                            <span>IN PROGRESS</span>
                                        </div>
                                        <p class="finzy-p-txt1">{{portfolio_info.portfolio_name}}</p>

                                        <p class="finzy-p-txt2">
                                            <!-- {{portfolio_info.risk}} -->
                                            ({{portfolio_info.portfolio_type}})-
                                            {{portfolio_info.portfolio_created_on}}
                                        </p>

                                        <div
                                            *ngIf="portfolio_info.portfolio_type == 'manual_invest' && portfolio_info.investment_amt == 0">

                                            <p class=" finzy-add-orange" style="padding-top: 28%;"><i
                                                    style="font-size: 80px;" class="material-icons">add_circle</i>
                                            </p>

                                            <p class="finzy-p-txt3" style="font-size: 20px;font-weight: bold;">
                                                CLOSED
                                            </p>

                                        </div>

                                        <div *ngIf="portfolio_info.investment_amt != 0">


                                            <div class="row finzy-rowtop"
                                                *ngIf="portfolio_info.portfolio_type == 'manual_invest' || portfolio_info.remaining_amt == 0">
                                                <div class="donutportfolio">

                                                    <div style="text-align: center;">

                                                        <app-doughnut
                                                            [dataSet]="findChartDataForPortfolio(portfolio_info._id)"
                                                            [centerText]="portfolio_info.roi + '%'"></app-doughnut>

                                                    </div>

                                                </div>
                                            </div>


                                        </div>

                                        <!-- manual invest -->
                                        <div *ngIf="portfolio_info.portfolio_type == 'manual_invest'">


                                            <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>

                                            <p class="finzy-p-txt4 finzy-blue"><span class="rupees finzy-blue">
                                                    <app-indian-currency-formatter
                                                        [amount]="portfolio_info.investment_amt">
                                                    </app-indian-currency-formatter>
                                                </span>
                                            </p>
                                        </div>
                                        <!-- manual invest -->

                                        <!-- auto invest -->
                                        <div
                                            *ngIf="['auto_invest', 'hybrid_invest', 'reinvest', 'finzy_bolt'].includes(portfolio_info.portfolio_type)">
                                            <div class="auto-invest-portfolio-remaining"
                                                *ngIf="portfolio_info.remaining_amt != 0">
                                                <div class="remaining-amount">
                                                    <p class="finzy-p-txt4 "><span class="rupees">
                                                            <app-indian-currency-formatter
                                                                [amount]="portfolio_info.remaining_amt">
                                                            </app-indian-currency-formatter>
                                                        </span>
                                                    </p>
                                                    <p class="finzy-p-txt3">REMAINING AMOUNT YET TO BE INVESTED</p>
                                                </div>
                                                <div class="investment-amount">
                                                    <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                                    <p class="finzy-p-txt4"><span class="rupees">
                                                            <app-indian-currency-formatter
                                                                [amount]="portfolio_info.investment_amt">
                                                            </app-indian-currency-formatter>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>

                                            <div *ngIf="portfolio_info.remaining_amt == 0">
                                                <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                                <p class="finzy-p-txt4 finzy-blue"><span class="rupees finzy-blue">
                                                        <app-indian-currency-formatter
                                                            [amount]="portfolio_info.investment_amt">
                                                        </app-indian-currency-formatter>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <!-- auto invest -->

                                    </div>
                                </div>
                                <div>
                                    <mat-toolbar (click)="toggleShowMoreAndShowLess()">
                                        <span class="title-center finzy-blue">Show More <i class="fa fa-arrow-down"
                                                aria-hidden="true"></i></span>
                                    </mat-toolbar>
                                </div>
                            </div>
                            <div *ngIf="!isShowMoreRequired && preferences">
                                <div *ngFor="let portfolio_info of lenderPortfolios">
                                    <div class="col-sm-3 finzy-portfolio"
                                        [ngClass]="{'pending-border' : portfolio_info.remaining_amt != 0}"
                                        *ngIf="portfolio_info.portfolio_type != 'reinvest' && portfolio_info.portfolio_type !== 'finzy_bolt'"
                                        (click)="goToPortfolio(portfolio_info._id)">
                                        <div class="ribbon"
                                            *ngIf="portfolio_info.remaining_amt != 0 &&
                       ['auto_invest', 'hybrid_invest', 'reinvest', 'finzy_bolt'].includes(portfolio_info.portfolio_type) ">
                                            <span>IN PROGRESS</span>
                                        </div>
                                        <p class="finzy-p-txt1">{{portfolio_info.portfolio_name}}</p>

                                        <p class="finzy-p-txt2">
                                            <!-- {{portfolio_info.risk}} -->
                                            ({{portfolio_info.portfolio_type}})-
                                            {{portfolio_info.portfolio_created_on}}
                                        </p>

                                        <div
                                            *ngIf="portfolio_info.portfolio_type == 'manual_invest' && portfolio_info.investment_amt == 0">

                                            <p class=" finzy-add-orange" style="padding-top: 28%;"><i
                                                    style="font-size: 80px;" class="material-icons">add_circle</i>
                                            </p>

                                            <p class="finzy-p-txt3" style="font-size: 20px;font-weight: bold;">
                                                CLOSED
                                            </p>

                                        </div>

                                        <div *ngIf="portfolio_info.investment_amt != 0">


                                            <div class="row finzy-rowtop"
                                                *ngIf="portfolio_info.portfolio_type == 'manual_invest' || portfolio_info.remaining_amt == 0">
                                                <div class="donutportfolio">

                                                    <div style="text-align: center;">

                                                        <app-doughnut
                                                            [dataSet]="findChartDataForPortfolio(portfolio_info._id)"
                                                            [centerText]="portfolio_info.roi + '%'"></app-doughnut>

                                                    </div>

                                                </div>
                                            </div>


                                        </div>

                                        <!-- manual invest -->
                                        <div *ngIf="portfolio_info.portfolio_type == 'manual_invest'">


                                            <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>

                                            <p class="finzy-p-txt4 finzy-blue"><span class="rupees finzy-blue">
                                                    <app-indian-currency-formatter
                                                        [amount]="portfolio_info.investment_amt">
                                                    </app-indian-currency-formatter>
                                                </span>
                                            </p>
                                        </div>
                                        <!-- manual invest -->

                                        <!-- auto invest -->
                                        <div
                                            *ngIf="['auto_invest', 'hybrid_invest', 'reinvest', 'finzy_bolt'].includes(portfolio_info.portfolio_type)">
                                            <div class="auto-invest-portfolio-remaining"
                                                *ngIf="portfolio_info.remaining_amt != 0">
                                                <div class="remaining-amount">
                                                    <p class="finzy-p-txt4 "><span class="rupees">
                                                            <app-indian-currency-formatter
                                                                [amount]="portfolio_info.remaining_amt">
                                                            </app-indian-currency-formatter>
                                                        </span>
                                                    </p>
                                                    <p class="finzy-p-txt3">REMAINING AMOUNT YET TO BE INVESTED</p>
                                                </div>
                                                <div class="investment-amount">
                                                    <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                                    <p class="finzy-p-txt4"><span class="rupees">
                                                            <app-indian-currency-formatter
                                                                [amount]="portfolio_info.investment_amt">
                                                            </app-indian-currency-formatter>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>

                                            <div *ngIf="portfolio_info.remaining_amt == 0">
                                                <p class="finzy-p-txt3">INVESTMENT AMOUNT</p>
                                                <p class="finzy-p-txt4 finzy-blue"><span class="rupees finzy-blue">
                                                        <app-indian-currency-formatter
                                                            [amount]="portfolio_info.investment_amt">
                                                        </app-indian-currency-formatter>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <!-- auto invest -->

                                    </div>
                                </div>
                                <div *ngIf="isShowLessRequired">
                                    <mat-toolbar (click)="toggleShowMoreAndShowLess()">
                                        <span class="title-center finzy-blue">Show Less <i class="fa fa-arrow-up"
                                                aria-hidden="true"></i></span>
                                    </mat-toolbar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row display-flex mt-2"
                    *ngIf="metrics?.numberOfLoansAsNPA > 0 || nonNpaDelayedLoansCount > 0">
                    <div class="col-md-12 metrics-table pt-4 pb-4">
                        <div class="row mb-2">
                            <p class="metrics-table-heading-alignment metrics-table-heading-font mb-0">
                                Delayed Loans
                                <span class="metrics-table-key pull-right mr-5"><a class="link sub-text"
                                        [routerLink]="getDelayedLoansRouterLink()"
                                        [queryParams]="{selectedIndex: 1}">View Details</a></span>
                            </p>
                        </div>
                        <div class="row metrics-table-heading-alignment">
                            <div class="row">
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Number of loans delayed > 90 days:</span>
                                    <span class="metrics-table-value pl-2">{{metrics.numberOfLoansAsNPA}}</span>
                                </div>
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Number of loans invested in:</span>
                                    <span class="metrics-table-value pl-2">{{metrics.numberOfLoansInvestedIn}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row display-flex mt-2"
                    *ngIf="metrics?.numberOfSettledLoans > 0 || metrics?.numberOfRestructuredLoans > 0">
                    <div class="col-md-12 metrics-table pt-4 pb-4">
                        <div class="row mb-2">
                            <p class="metrics-table-heading-alignment metrics-table-heading-font mb-0">
                                Settled / Restructured Loans

                                <span class="metrics-table-key pull-right mr-5"
                                    *ngIf="metrics?.numberOfRestructuredLoans > 0"><a class="link sub-text"
                                        [routerLink]="getDelayedLoansRouterLink()"
                                        [queryParams]="{selectedIndex: 4}">View Restructured Loans</a></span>
                                <span class="metrics-table-key pull-right mr-5"
                                    *ngIf="metrics?.numberOfSettledLoans > 0"><a class="link sub-text"
                                        [routerLink]="getDelayedLoansRouterLink()"
                                        [queryParams]="{selectedIndex: 3}">View Settled Loans</a></span>
                            </p>
                        </div>
                        <div class="row metrics-table-heading-alignment">
                            <div class="row" *ngIf="metrics?.numberOfSettledLoans > 0">
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Number of Settled loans:</span>
                                    <span class="metrics-table-value pl-2">{{metrics.numberOfSettledLoans}}</span>
                                </div>
                                <div class="col-md-4">
                                </div>
                            </div>
                            <div class="row finzy-padding-top-2" *ngIf="metrics?.numberOfRestructuredLoans > 0">
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Number of Restructured loans:</span>
                                    <span class="metrics-table-value pl-2">{{metrics.numberOfRestructuredLoans}}</span>
                                </div>
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Capitalised Interest - Restructuring:</span>
                                    <span class="metrics-table-value pl-2">
                                        <app-indian-currency-formatter
                                            [amount]="metrics.capitalizedInterestDueToRestructuring">
                                        </app-indian-currency-formatter>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row display-flex mt-2" *ngIf="metrics?.writtenOff?.principal > 0">
                    <div class="col-md-12 metrics-table pt-4 pb-4">
                        <div class="row mb-2">
                            <p class="metrics-table-heading-alignment metrics-table-heading-font mb-0">
                                Sub Standard / Loss Asset Loans
                                <span class="metrics-table-key pull-right mr-5"><a class="link sub-text"
                                        [routerLink]="getDelayedLoansRouterLink()"
                                        [queryParams]="{selectedIndex: 2}">View Details</a></span>
                            </p>
                            <p class="metrics-table-heading-alignment">
                                Click <a [href]="getFileUrlByFileName('loanClassificationAndTreatment')" target="_blank" class="link">here</a>
                                to
                                know more about
                                classifications of loans at finzy
                            </p>
                        </div>
                        <div class="row metrics-table-heading-alignment">
                            <div class="row">
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Sub Standard Asset :</span>
                                    <span
                                        class="metrics-table-value pl-2">{{metrics.numberOfSubStandardAssetLoans}}</span>
                                </div>
                                <div class="col-md-4" *ngIf="metrics?.numberOfLossAssetLoans > 0">
                                    <span class="metrics-table-key">Loss Asset :</span>
                                    <span class="metrics-table-value pl-2">{{metrics.numberOfLossAssetLoans}}</span>
                                </div>

                                <div class="col-md-4">
                                    <span class="metrics-table-key">Total Principal Amount Written-off :</span>
                                    <span class="metrics-table-value pl-2">
                                        <app-indian-currency-formatter [amount]="metrics?.writtenOff?.principal">
                                        </app-indian-currency-formatter>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row display-flex mt-2" *ngIf="metrics?.capitalisedInterest > 0">
                    <div class="col-md-12 metrics-table pt-4 pb-4">
                        <div class="row mb-2">
                            <p class="metrics-table-heading-alignment metrics-table-heading-font mb-0">
                                EMI Moratorium
                            </p>
                            <p class="metrics-table-heading-alignment">
                                Click <a
                                    [href]="getFileUrlByFileName('emiMoratorium')"
                                    target="_blank" class="link">here</a> to know more about
                                EMI Moratorium.
                            </p>
                        </div>
                        <div class="row metrics-table-heading-alignment">
                            <div class="row">
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Loans opted for EMI moratorium :</span>
                                    <span
                                        class="metrics-table-value pl-2">{{metrics.numberOfLoansWithMoratorium}}</span>
                                </div>
                                <div class="col-md-4">
                                    <span class="metrics-table-key">Capitalised Interest :</span>
                                    <span class="metrics-table-value pl-2">
                                        <app-indian-currency-formatter [amount]="metrics.capitalisedInterest">
                                        </app-indian-currency-formatter>
                                        &nbsp;
                                    </span>
                                    <app-tooltip placement="bottom">
                                        <i class="info-icon material-icons" trigger>info_outline</i>
                                        <div content style="text-align: justify">
                                            <span style="font-weight: bold; color: #0d3ab3">What is Capitalised
                                                Interest?</span><br>
                                            When a loan that you have invested in applies for a moratorium, the
                                            interest
                                            due
                                            for those months of moratorium are added to principal outstanding, which
                                            is
                                            referred
                                            to as Capitalised Interest. Your principal outstanding amount would
                                            increase
                                            by the
                                            capitalised
                                            interest amount and you will earn returns, as the borrower will be
                                            paying
                                            interest on this
                                            accrued interest.
                                        </div>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>